var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"container"},[_c('h3',{staticClass:"header"},[_vm._v("30 Günlük Plan")]),_c('hr'),_c('PlanList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }